// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.productCardButtons {
    display: none !important;
}
.hiddenHover{
    display: none;
}
body{
    overflow: scroll !important;
}

.productCard:hover .hiddenHover{
    display: flex;
}

.fas, .fa-chevron-down {
    margin:10px !important;
}
.productCard:hover .productCardButtons {
    display: flex !important;
    flex-direction: column;
    position: absolute;
    right: 4px;
}

.productCard {
    cursor: pointer;
    position: relative;
}

.productCardShop {
    position: relative;
}

.stockSection{
    border-bottom: 0.5px solid rgb(255, 158, 23);
    margin-bottom: 1%;
}

@media (max-width: 970px) and (min-width: 200px) {
    .stockSection {
        padding-bottom: 30px;
    }
}

.disabledSection{
    border-color: #999999;
}

.selectedModel .productCard{
    border: 2px solid rgb(255, 158, 23);
    border-radius: 5px;
}

.btnBo{
    background: rgb(255, 158, 23);
    color: white;
}

.btnBo:hover{
    color: white;

}
.btn:focus {
    box-shadow: none!important;
}

.stockSectionContent{
    display: flex;
    align-items: center;
}

.stockSection .step{
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 10px;
}

.stockSection.disabledSection .step{
    color: #999999;
}

.productCard:hover  span,
.productCardShop:hover  span{
    display: block !important;
}

.productCardHeader {
    display: flex !important;
}

.productCard:hover  .productCardHeader,
.productCardShop:hover  .productCardHeader{
    display: none !important;
}

.productCard .actionLink,
.productCardShop .actionLink {
    padding: 0;
    margin: 0;
    margin-bottom: 5px;
}

.removeSerial .actionLink,
.dlSV .actionLink{
    width: auto;
}

.productCardButtons {
    margin-top: 10px;
}

.filters .dropdown {
    max-width: 250px;
}

.header__shop__stock .filters {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
}

.stockText {
    margin-right: auto;
    padding: 0.5rem;
}

.productCard,
.productCardShop {
    background-color: #eee;
    transition: transform 0.5s;
}
.productCard::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transition: opacity 2s cubic-bezier(0.165, 0.84, 0.44, 1);
    box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.15);
    content: "";
    opacity: 0;
    z-index: -1;
}
.productCard:hover::after, .productCardContent:focus::after {
    opacity: 1;
}

.actionLink:hover svg {
    color: rgb(255, 158, 23);
}

.actionLink {
    width: 100%;
}

@media (max-width: 970px) and (min-width: 200px) {
    .stockSectionContent .justify-content-end {
        flex-direction: column;
    }
    .form-group {
        width: 100%;
        max-width: 100%;
    }
    .step {
        margin-top: 10px;
    }
}

.nbSeal {
    font-size: 1.5rem;
    font-weight: bold;
}

.nbSealGreen {
    color: green;
}

.nbSealRed {
    color: red;
}

.previewImg {
    cursor: pointer;
    height: 10rem;
}

.ui.selection.active.dropdown .menu {
    border-color: rgb(255, 158, 23)!important;
}

.ui.selection.active.dropdown {
    border-color: rgb(255, 158, 23)!important;
}

.form-control:focus {
    border-color: rgb(255, 158, 23);
    box-shadow: 0 0 0 0.2rem rgba(255, 158, 23, 0.25);
}
.custom-select:focus {
    border-color: rgb(255, 158, 23);
    box-shadow: 0 0 0 0.2rem rgba(255, 158, 23, 0.25);
}

body  {
    overflow-x: hidden!important;
}

.custom-control-input:checked ~ .custom-control-label::before {
    background-color: rgb(255, 158, 23);
    border-color: rgb(255, 158, 23);
    box-shadow: 0 0 0 0.2rem rgba(255, 158, 23, 0.25);
}

.custom-control-input:active ~ .custom-control-label::before {
   background-color: rgba(255, 158, 23, 0.25)!important;
    border-color: rgb(255, 158, 23)!important;
}

.custom-control-input:checked[disabled] ~ .custom-control-label::before {
    background-color: rgb(255, 158, 23)!important;
    opacity: 0.5!important;
    /*background-color: white!important;*/
    /*box-shadow: none;*/
    /*border-color: rgba(255, 158, 23, 0.25)!important;*/
}

.modal-container {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
}


.fullSize {
    overflow-y: auto;
    overflow-x: hidden;
    max-height: calc(100vh - 150px);
}


.customSpinner {
    border-color: rgb(255, 158, 23);
    border-right-color: transparent;
}

.flash {
    background-color: white;
    border: black solid 2px;
    border-radius: 5px;
    width: 50px;
    height: 50px;
    color: black;
    font-size: 25px;
}

.flashOn {
    border-color: rgb(255, 158, 23);
    color: rgb(255, 158, 23);
}

.productModalLabel {
    font-weight: bold;
}

.productModalGrp {
    height: 10vh;
}

.showError {
    border: 1px solid rgb(255, 158, 23);
    border-radius: 5px;
    background-color: rgba(255, 158, 23, 0.3);
    padding: 5px;
    width: max-content;
    margin-top: 3px;
}

.line-separator {
    border-bottom: 0.5px solid #DEDEDE;
}
`, "",{"version":3,"sources":["webpack://./src/App/css/bo.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;AAC5B;AACA;IACI,aAAa;AACjB;AACA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;AACA;IACI,wBAAwB;IACxB,sBAAsB;IACtB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,4CAA4C;IAC5C,iBAAiB;AACrB;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,YAAY;;AAEhB;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;;IAEI,UAAU;IACV,SAAS;IACT,kBAAkB;AACtB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,sBAAsB;IACtB,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,yDAAyD;IACzD,6EAA6E;IAC7E,WAAW;IACX,UAAU;IACV,WAAW;AACf;AACA;IACI,UAAU;AACd;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,+BAA+B;IAC/B,iDAAiD;AACrD;AACA;IACI,+BAA+B;IAC/B,iDAAiD;AACrD;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mCAAmC;IACnC,+BAA+B;IAC/B,iDAAiD;AACrD;;AAEA;GACG,oDAAoD;IACnD,yCAAyC;AAC7C;;AAEA;IACI,6CAA6C;IAC7C,sBAAsB;IACtB,qCAAqC;IACrC,oBAAoB;IACpB,oDAAoD;AACxD;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;AACxC;;;AAGA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,+BAA+B;AACnC;;;AAGA;IACI,+BAA+B;IAC/B,+BAA+B;AACnC;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,yCAAyC;IACzC,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kCAAkC;AACtC","sourcesContent":[".productCardButtons {\n    display: none !important;\n}\n.hiddenHover{\n    display: none;\n}\nbody{\n    overflow: scroll !important;\n}\n\n.productCard:hover .hiddenHover{\n    display: flex;\n}\n\n.fas, .fa-chevron-down {\n    margin:10px !important;\n}\n.productCard:hover .productCardButtons {\n    display: flex !important;\n    flex-direction: column;\n    position: absolute;\n    right: 4px;\n}\n\n.productCard {\n    cursor: pointer;\n    position: relative;\n}\n\n.productCardShop {\n    position: relative;\n}\n\n.stockSection{\n    border-bottom: 0.5px solid rgb(255, 158, 23);\n    margin-bottom: 1%;\n}\n\n@media (max-width: 970px) and (min-width: 200px) {\n    .stockSection {\n        padding-bottom: 30px;\n    }\n}\n\n.disabledSection{\n    border-color: #999999;\n}\n\n.selectedModel .productCard{\n    border: 2px solid rgb(255, 158, 23);\n    border-radius: 5px;\n}\n\n.btnBo{\n    background: rgb(255, 158, 23);\n    color: white;\n}\n\n.btnBo:hover{\n    color: white;\n\n}\n.btn:focus {\n    box-shadow: none!important;\n}\n\n.stockSectionContent{\n    display: flex;\n    align-items: center;\n}\n\n.stockSection .step{\n    font-size: 1.5rem;\n    font-weight: bold;\n    margin-bottom: 10px;\n}\n\n.stockSection.disabledSection .step{\n    color: #999999;\n}\n\n.productCard:hover  span,\n.productCardShop:hover  span{\n    display: block !important;\n}\n\n.productCardHeader {\n    display: flex !important;\n}\n\n.productCard:hover  .productCardHeader,\n.productCardShop:hover  .productCardHeader{\n    display: none !important;\n}\n\n.productCard .actionLink,\n.productCardShop .actionLink {\n    padding: 0;\n    margin: 0;\n    margin-bottom: 5px;\n}\n\n.removeSerial .actionLink,\n.dlSV .actionLink{\n    width: auto;\n}\n\n.productCardButtons {\n    margin-top: 10px;\n}\n\n.filters .dropdown {\n    max-width: 250px;\n}\n\n.header__shop__stock .filters {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 24px;\n}\n\n.stockText {\n    margin-right: auto;\n    padding: 0.5rem;\n}\n\n.productCard,\n.productCardShop {\n    background-color: #eee;\n    transition: transform 0.5s;\n}\n.productCard::after {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    transition: opacity 2s cubic-bezier(0.165, 0.84, 0.44, 1);\n    box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.15);\n    content: \"\";\n    opacity: 0;\n    z-index: -1;\n}\n.productCard:hover::after, .productCardContent:focus::after {\n    opacity: 1;\n}\n\n.actionLink:hover svg {\n    color: rgb(255, 158, 23);\n}\n\n.actionLink {\n    width: 100%;\n}\n\n@media (max-width: 970px) and (min-width: 200px) {\n    .stockSectionContent .justify-content-end {\n        flex-direction: column;\n    }\n    .form-group {\n        width: 100%;\n        max-width: 100%;\n    }\n    .step {\n        margin-top: 10px;\n    }\n}\n\n.nbSeal {\n    font-size: 1.5rem;\n    font-weight: bold;\n}\n\n.nbSealGreen {\n    color: green;\n}\n\n.nbSealRed {\n    color: red;\n}\n\n.previewImg {\n    cursor: pointer;\n    height: 10rem;\n}\n\n.ui.selection.active.dropdown .menu {\n    border-color: rgb(255, 158, 23)!important;\n}\n\n.ui.selection.active.dropdown {\n    border-color: rgb(255, 158, 23)!important;\n}\n\n.form-control:focus {\n    border-color: rgb(255, 158, 23);\n    box-shadow: 0 0 0 0.2rem rgba(255, 158, 23, 0.25);\n}\n.custom-select:focus {\n    border-color: rgb(255, 158, 23);\n    box-shadow: 0 0 0 0.2rem rgba(255, 158, 23, 0.25);\n}\n\nbody  {\n    overflow-x: hidden!important;\n}\n\n.custom-control-input:checked ~ .custom-control-label::before {\n    background-color: rgb(255, 158, 23);\n    border-color: rgb(255, 158, 23);\n    box-shadow: 0 0 0 0.2rem rgba(255, 158, 23, 0.25);\n}\n\n.custom-control-input:active ~ .custom-control-label::before {\n   background-color: rgba(255, 158, 23, 0.25)!important;\n    border-color: rgb(255, 158, 23)!important;\n}\n\n.custom-control-input:checked[disabled] ~ .custom-control-label::before {\n    background-color: rgb(255, 158, 23)!important;\n    opacity: 0.5!important;\n    /*background-color: white!important;*/\n    /*box-shadow: none;*/\n    /*border-color: rgba(255, 158, 23, 0.25)!important;*/\n}\n\n.modal-container {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 9999;\n}\n\n.modal-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n}\n\n\n.fullSize {\n    overflow-y: auto;\n    overflow-x: hidden;\n    max-height: calc(100vh - 150px);\n}\n\n\n.customSpinner {\n    border-color: rgb(255, 158, 23);\n    border-right-color: transparent;\n}\n\n.flash {\n    background-color: white;\n    border: black solid 2px;\n    border-radius: 5px;\n    width: 50px;\n    height: 50px;\n    color: black;\n    font-size: 25px;\n}\n\n.flashOn {\n    border-color: rgb(255, 158, 23);\n    color: rgb(255, 158, 23);\n}\n\n.productModalLabel {\n    font-weight: bold;\n}\n\n.productModalGrp {\n    height: 10vh;\n}\n\n.showError {\n    border: 1px solid rgb(255, 158, 23);\n    border-radius: 5px;\n    background-color: rgba(255, 158, 23, 0.3);\n    padding: 5px;\n    width: max-content;\n    margin-top: 3px;\n}\n\n.line-separator {\n    border-bottom: 0.5px solid #DEDEDE;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
